import { IsNotEmpty, ValidateNested } from "class-validator";
import { Type } from "class-transformer";

import { DogClassDto } from "./dog-class.dto";
import { IScoreDogClass } from "./score-dog-class.interface";

export class ScoreDogClassDto implements IScoreDogClass {
  //
  @IsNotEmpty()
  score_id: string;

  @IsNotEmpty()
  @ValidateNested()
  @Type(() => DogClassDto)
  dog_class: DogClassDto;
}
